import React from 'react';
import PropTypes from 'prop-types';
import TabContent from './TabContent';

const DesignTabContent = (props) => {
    const { tab, active } = props;
    return <TabContent tab={tab} active={active} />;
};

DesignTabContent.defaultProps = {};

DesignTabContent.propTypes = {
    tab: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
};

export default DesignTabContent;
